import { useRef, useState, useEffect, useCallback } from 'react';

export function HorizontalScrollTable({ children }) {
  const scrollRef = useRef(null);
  const topBarRef = useRef(null);
  const [contentWidth, setContentWidth] = useState(0);
  const [hasOverflow, setHasOverflow] = useState(false);
  const syncing = useRef(false);

  const checkOverflow = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    const overflow = el.scrollWidth > el.clientWidth + 2;
    setHasOverflow(overflow);
    setContentWidth(el.scrollWidth);
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    checkOverflow();
    const ro = new ResizeObserver(checkOverflow);
    ro.observe(el);
    const mo = new MutationObserver(checkOverflow);
    mo.observe(el, { childList: true, subtree: true });
    return () => { ro.disconnect(); mo.disconnect(); };
  }, [checkOverflow]);

  const onTopScroll = () => {
    if (syncing.current) return;
    syncing.current = true;
    if (scrollRef.current && topBarRef.current) {
      scrollRef.current.scrollLeft = topBarRef.current.scrollLeft;
    }
    requestAnimationFrame(() => { syncing.current = false; });
  };

  const onTableScroll = () => {
    if (syncing.current) return;
    syncing.current = true;
    if (scrollRef.current && topBarRef.current) {
      topBarRef.current.scrollLeft = scrollRef.current.scrollLeft;
    }
    requestAnimationFrame(() => { syncing.current = false; });
  };

  return (
    <div className="relative">
      {/* Top scrollbar */}
      <div
        ref={topBarRef}
        onScroll={onTopScroll}
        className="overflow-x-auto overflow-y-hidden border-b"
        style={{
          height: hasOverflow ? '16px' : '0px',
          opacity: hasOverflow ? 1 : 0,
          transition: 'height 0.2s',
        }}
      >
        <div style={{ width: contentWidth, height: '16px' }} />
      </div>
      {/* Table content */}
      <div
        ref={scrollRef}
        onScroll={onTableScroll}
        className="overflow-x-auto"
      >
        {children}
      </div>
    </div>
  );
}
